import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Cliente } from '../../models/cliente';
import { Validation } from '../../config/validation';
import { SweetMessage } from '../../config/sweet-message';
import { ClienteService } from '../../services/cliente.service';
import { SessionService } from '../../services/session.service';
import { ValidarCorreoService } from '../../services/validar-correo.service';

@Component({
	selector: 'app-cliente-frm-add',
	templateUrl: './cliente-frm-add.component.html',
	styleUrls: ['./cliente-frm-add.component.css'],
	providers: [ClienteService, SessionService, ValidarCorreoService]
})
export class ClienteFrmAddComponent implements OnInit {
	@ViewChild('identificacionFocus') identificacionElement: ElementRef;
	@Input() btnCalelHidden: boolean = false;
    public cliente: Cliente;
	public vl: Validation;
	public title: String;
	private msgSweet: SweetMessage;
	public loading = false;
	public correos: Array<any>;
	public correo_invalid:Boolean;

	constructor(
		public fb: FormBuilder,
		private clienteService: ClienteService,
		private ss: SessionService,
		public correoService: ValidarCorreoService,
	) {
		this.cliente = new Cliente();
		this.cliente.tipo_identificacion_id = 2;
		this.cliente.tipo_persona = "N";
		this.vl = new Validation();
		this.correos = [];
		this.msgSweet = new SweetMessage();
		this.correo_invalid = false;
	}

	ngOnInit() {
		
		setTimeout(()=>{ 
				this.identificacionElement.nativeElement.focus();
				
		
		},0);
	}

	getNombreComercial(){
		return this.cliente.nombre_comercial = this.cliente.razon_social;
	}

	isValidForm(){
		if(!this.cliente.razon_social){
			return false
		}
		if(this.cliente.nombre_comercial =='' && this.cliente.tipo_persona!='N'){
				return false
		}
		if(!this.cliente.dni){
			return false
		}
		if(!this.cliente.telefono){
			return false
		}
		if(!this.cliente.direccion){
			return false
		}
		if(!this.cliente.tipo_persona){
			return false
		}
		if(!this.cliente.tipo_identificacion_id){
			return false
		}
		if(this.cliente.es_contribuyente){
			if(!this.cliente.num_contribuyente){
				return false;
			}
		}
		if(this.cliente.dni){
			if(this.cliente.tipo_identificacion_id == 1){
				if( this.cliente.dni.length != 13 ){
					return false;
				}else if( isNaN(this.cliente.dni.toString() as any) ){
					return false;
				}
			}
			if(this.cliente.tipo_identificacion_id == 2){
				if( this.cliente.dni.length != 10 ){
					return false;
				}else if( isNaN(this.cliente.dni.toString() as any) ){
					return false;
				}
			}
			if(this.cliente.tipo_identificacion_id == 3 && this.cliente.dni.length < 4 ){
				return false;
			}
		}

		if(this.cliente.telefono && this.cliente.telefono.length < 4){
			return false;
		}

		if(this.cliente.celular && this.cliente.celular.length < 4){
			return false;
		}
		/*if( !this.correos.length ){
			return false;
		}*/
		if (this.correo_invalid) {
			return false;
		}

		return true;
	}

	onSubmit(){
		this.loading = true;
		this.setValueEntity();
		this.clienteService.save(this.cliente).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.cliente = new Cliente();
				this.cliente.tipo_identificacion_id = 2;
				this.cliente.tipo_persona = "N";
			},
			err => {
				this.loading = false;
				this.msgSweet.showMessage('error-message',err);
			}
		);
	}
	
	setValueEntity(){
		this.cliente.empresa_id = this.ss.getData("empresa_id");
		this.cliente.usuario_id = this.ss.getData("usuario_id");
		this.cliente.razon_social = this.cliente.razon_social.trim();
		this.cliente.nombre_comercial = this.cliente.razon_social.trim();
		this.cliente.correo = this.correos.toString();
		switch (this.cliente.tipo_identificacion_id){
			case 1: 
				this.cliente.tipo_dni = "RUC";
				break;
			case 2: 
				this.cliente.tipo_dni = "CED";
				break;
			case 3:
				this.cliente.tipo_dni = "PAS";
				break;
		}
	}

	onChangeIdentificacion(id){
		this.cliente.tipo_identificacion_id = id;
		if(this.cliente.tipo_persona == "N"){
			this.cliente.nombre_comercial = '';
		}
		if(this.cliente.tipo_identificacion_id == 2){
			this.cliente.nombre_comercial = '';
			this.cliente.tipo_persona = "N";
		}
		if(this.cliente.tipo_identificacion_id == 1){
			this.cliente.tipo_persona = "J";
		}
		setTimeout(()=>{ 
			this.identificacionElement.nativeElement.focus();
		},0);
	}

	onChangeTipoPersona(){
		if(this.cliente.tipo_persona == 'N'){
			this.cliente.nombre_comercial = '';
			this.cliente.tipo_identificacion_id = 2;
		}
		if(this.cliente.tipo_persona == 'J'){
			this.cliente.tipo_identificacion_id = 1;
		}

		setTimeout(()=>{ 
			this.identificacionElement.nativeElement.focus();
		},0);
	}

	validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/forms/cliente-frm-add/cliente-frm-add.component.ts